<template>
  <h1 class="text-white text-center font-bold p-4 border-b">لیست فاکتور های امروز</h1>

  <TabGroup :defaultIndex="0">
    <TabList class="flex justify-between p-4">
      <Tab v-slot="{ selected }">
        <span class="text-white py-1 px-2 text-sm rounded-lg border border-yellow-500"
              :class="[selected ? 'bg-yellow-500' : '']">
          فاکتور من
        </span>
      </Tab>
      <Tab v-slot="{ selected }">
        <span class="text-white py-1 px-2 text-sm rounded-lg border border-yellow-500"
              :class="[selected ? 'bg-yellow-500' : '']">
          فاکتور مشتری
        </span>
      </Tab>
      <Tab v-slot="{ selected }">
        <span class="text-white py-1 px-2 text-sm rounded-lg border border-yellow-500"
              :class="[selected ? 'bg-yellow-500' : '']">
          فاکتور میز
        </span>
      </Tab>
    </TabList>
    <TabPanels>

      <TabPanel>
        <div class="mx-4" v-if="myFactors.length > 0">
          <MyFactorCard
              v-for="factor in myFactors"
              :key="factor.factoR_ID"
              :factor="factor"
              @refresh="getMyFactor()"/>
        </div>
        <div v-else>
          <h1 class="text-gray-300 text-center mt-10">فاکتوری وجود ندارد</h1>
        </div>
      </TabPanel>

      <TabPanel>
        <div class="mx-4" v-if="customerFactors.length > 0">
          <MyFactorCard
              v-for="factor in customerFactors"
              :key="factor.factoR_ID"
              :factor="factor"
              @refresh="getCustomerFactors()"/>
        </div>
        <div v-else>
          <h1 class="text-gray-300 text-center mt-10">فاکتوری وجود ندارد</h1>
        </div>
      </TabPanel>

      <TabPanel>
        <div class="mx-4">
          <form action="" @submit.prevent="getDeskFactor()">
            <div class="flex mt-2">
              <Input type="number" placeholder="شماره میز" v-model="deskNumber" required/>

              <Button class="flex-1 p-2 mr-2" type="submit">
                <SearchIcon class="h-6 w-6"/>
              </Button>
            </div>
          </form>

          <div v-if="deskFactors.length > 0">
            <MyFactorCard
                v-for="factor in deskFactors"
                :key="factor.factoR_ID"
                :factor="factor"
                @refresh="getDeskFactor()"/>
          </div>

          <div v-else>
            <h1 class="text-gray-300 text-center mt-10">فاکتوری وجود ندارد</h1>
          </div>

        </div>
      </TabPanel>
    </TabPanels>
  </TabGroup>

</template>

<script>
import {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/vue'
import {getFactorHistory} from "@/API/API";
import MyFactorCard from "@/components/FactorCard";
import Button from "@/components/General/Button";
import Input from "@/components/Input";
import {SearchIcon} from "@heroicons/vue/outline";

export default {
  name: "FactorList",
  components: {MyFactorCard, Button, Input, TabGroup, TabList, Tab, TabPanels, TabPanel, SearchIcon},
  data() {
    return {
      myFactors: [],
      deskFactors: [],
      customerFactors: [],
      deskNumber: ''
    }
  },
  created() {
    this.getMyFactor()
    this.getCustomerFactors()
  },
  methods: {
    async getMyFactor() {
      this.myFactors = (await getFactorHistory()).data.result
    },
    async getCustomerFactors() {
      this.customerFactors = (await getFactorHistory('', true)).data.result
    },
    async getDeskFactor() {
      this.deskFactors = (await getFactorHistory(this.deskNumber)).data.result
    },
  }
}
</script>

<style scoped>

</style>